import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { SearchType } from '@aibees/elephant/types';
import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { LookalikeButtonTooltipContentProps as Props } from './types';

export const LookalikeButtonTooltipContent = memo(
  ({ className, max, onClose }: Props) => {
    const type = useSearchTypeFromRoute();

    return (
      <Styled.Wrapper
        className={classnames('LookalikeButtonTooltipContent', className)}
        sx={SX.root}
      >
        <Styled.Box>
          <Icon name="info-1" size={24} />
        </Styled.Box>
        <Styled.Box>{`Reached ${max} Lookalike ${
          type === SearchType.People ? 'People' : 'Domain'
        } limit. Remove to add new ones.`}</Styled.Box>
        <Styled.Box>
          <Styled.CloseIcon onClick={onClose} name="close" size={20} />
        </Styled.Box>
      </Styled.Wrapper>
    );
  }
);

LookalikeButtonTooltipContent.displayName = 'LookalikeButtonTooltipContent';
